import { Users } from "@similarweb/icons";

import type { IFiltersConfigCategoryItem } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";

import { type ContactsFilterCategory, contactsFilterCategoryMap } from "../types/contactsFilterCategory";

export const contactsCategories = {
    contacts: {
        id: contactsFilterCategoryMap.contacts,
        order: 80,
        icon: Users,
        titleKey: advancedFilteringI18nKeys.category(contactsFilterCategoryMap.contacts),
    },
} as const satisfies Record<ContactsFilterCategory, IFiltersConfigCategoryItem>;
